import { useEffect, useRef } from 'react';
import { trackPostHog } from './analytics';

const THRESHOLDS = [25, 50, 75, 90] as const;

export function useScrollDepth(pageName: string) {
  const fired = useRef<Set<number>>(new Set());

  useEffect(() => {
    const onScroll = () => {
      const doc = document.documentElement;
      const scrolled = window.scrollY + window.innerHeight;
      const total = doc.scrollHeight;
      if (total <= window.innerHeight) return;
      const pct = Math.round((scrolled / total) * 100);
      for (const t of THRESHOLDS) {
        if (pct >= t && !fired.current.has(t)) {
          fired.current.add(t);
          trackPostHog('scroll_depth', { depth: t, page: pageName });
        }
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, [pageName]);
}
